import Utils from "../services/utils-service.js";
import Driver from "../services/driver-service.js";
import Funnel from "../services/funnel-service.js";
import router from "../router.js";

const puid = 'pg_drivers_summary';

export default {
    actions: {
        createDriverElem(context, data) {
            const $fs = new Funnel({ ctx: context });
            const reqType = $fs.getReqType(puid);
            const $endpoint = `/api?req=${reqType}&action=add-driver`;
            $.ajax({
                type: 'POST',
                url: $endpoint,
                data: data.payload,
                beforeSend: function () {
                    $fs.startPageLoading(puid);
                },
                success: function (res) {
                    console.log('Driver created ', res);
                    if (!Utils.isEmpty(res) && Object.keys(res).length > 0 && res.error === undefined) {
                        if (Object.keys(res.data).length > 0) {
                            $fs.commitMutations(res.data);
                        }
                        if (Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {

                                const drv = new Driver({ ctx: context });
                                const drvCount = drv.getDriversCount();
                                drv.createDriverAdHocSeq(drvCount);

                                context.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_new_driver', key: 'loading', val: false });
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }
                    $fs.completePageLoading(puid);
                },
                error: function () {
                    $fs.completePageLoading(puid);
                }
            });
        },
        editDriverElem(context, data) {
            console.log('editDriverElem: data', data);
            const $fs = new Funnel({ ctx: context });
            const reqType = $fs.getReqType(puid);
            const $endpoint = `/api?req=${reqType}&action=edit-driver`;
            $.ajax({
                type: 'POST',
                url: $endpoint,
                data: data,
                beforeSend: function () {
                    $fs.startPageLoading(puid);
                },
                success: function (res) {
                    console.log('Driver edited ', res);
                    if (!Utils.isEmpty(res) && Object.keys(res).length > 0 && res.error === undefined) {
                        if (Object.keys(res.data).length > 0) {
                            $fs.commitMutations(res.data);
                        }
                        if (Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }
                    $fs.completePageLoading(puid);
                },
                error: function () {
                    $fs.completePageLoading(puid);
                }
            });
        },
        deleteDriverElem(context, data) {
            console.log('deleteDriverElem: data', data);
            const $fs = new Funnel({ ctx: context });
            const reqType = $fs.getReqType(puid);
            const $endpoint = `/api?req=${reqType}&action=delete-driver`;
            $.ajax({
                type: 'POST',
                url: $endpoint,
                data: data,
                beforeSend: function () {
                    $fs.startPageLoading(puid);
                },
                success: function (res) {
                    console.log('Driver deleted ', res);
                    if (res != null && Object.keys(res).length > 0 && res.error === undefined) {
                        if (Object.keys(res.data).length > 0) {
                            $fs.commitMutations(res.data);
                        }
                        if (Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }
                    $fs.completePageLoading(puid);
                },
                error: function () {
                    $fs.completePageLoading(puid);
                }
            });
        }
    }
}